export default "__VITE_PUBLIC_ASSET__f49e255a__"